/**
 * Shared cache TTL constants for all Zustand stores.
 * All values are in milliseconds.
 */

/** 2 minutes – budgets (frequently updated) */
export const BUDGET_CACHE_TTL = 2 * 60 * 1000;

/** 5 minutes – accounts, goals, groups */
export const SHORT_CACHE_TTL = 5 * 60 * 1000;

/** 1 hour – transactions (large dataset, rarely changes mid-session) */
export const LONG_CACHE_TTL = 60 * 60 * 1000;

/** 24 hours – one-time operations like balance recalculation */
export const DAY_TTL = 24 * 60 * 60 * 1000;
